import { env } from '@/env'

const TRUST_BADGES = ['SOC 2 Type II', 'ISO 27001', 'GDPR'] as const

function CheckBadge({ label }: { label: string }) {
  return (
    <i className="foot__badge">
      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth={1.6}>
        <circle cx="8" cy="8" r="6.4" />
        <path d="M5.3 8.2l1.9 1.9 3.6-3.9" />
      </svg>
      {label}
    </i>
  )
}

/**
 * Legal foot of the form pane — copyright, compliance badges, policy links.
 *
 * Mirrors Passport's foot, plus one Lobby addition: a non-production
 * environment tag. Staging and production are otherwise pixel-identical,
 * and a tester who can't tell them apart files bugs against the wrong one.
 */
export function Footer() {
  const appEnv = env.VITE_APP_ENV
  const showEnvLabel = appEnv !== 'production'

  return (
    <div className="foot">
      <span>&copy; {new Date().getFullYear()} Spaceti</span>

      <span className="foot__trust" aria-label="Compliance">
        {TRUST_BADGES.map((label) => (
          <CheckBadge key={label} label={label} />
        ))}
      </span>

      <span className="foot__links">
        {showEnvLabel ? (
          <span className="foot__env" aria-label={`Environment: ${appEnv}`}>
            {appEnv}
          </span>
        ) : null}
        <a href="https://spaceti.com/privacy" target="_blank" rel="noopener">
          Privacy
        </a>
        <a href="https://spaceti.com/terms" target="_blank" rel="noopener">
          Terms
        </a>
        <a
          className="dk"
          href="https://status.spaceti.com"
          target="_blank"
          rel="noopener"
        >
          Status
        </a>
      </span>
    </div>
  )
}
